<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Quản lý"
          :link="[
            { text: 'Cơ sở vật chất', href: '/facility' },
            { text: 'Quản lý Kho & Xuất Nhập Tồn', href: '/facility/transfers' }
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn depressed dark color="primary" @click="newDialog = !newDialog">
          <v-icon left>mdi-plus</v-icon> Lập phiếu mới
        </v-btn>
      </div>
    </div>

    <v-card outlined class="mx-4 mb-4 elevation-0">
      <v-tabs v-model="activeTab" background-color="transparent" color="primary">
        <v-tab><v-icon left small>mdi-warehouse</v-icon> Tồn kho theo Kho</v-tab>
        <v-tab><v-icon left small>mdi-swap-horizontal</v-icon> Phiếu Xuất - Nhập - Luân chuyển</v-tab>
        <v-tab><v-icon left small>mdi-file-chart</v-icon> Báo cáo Thẻ kho (Xuất - Nhập - Tồn)</v-tab>
      </v-tabs>
    </v-card>

    <v-tabs-items v-model="activeTab" class="transparent">
      <!-- TAB 1: TỒN KHO THEO KHO -->
      <v-tab-item>
        <v-card outlined class="mx-4 elevation-0">
          <StockByLocationTable />
        </v-card>
      </v-tab-item>

      <!-- TAB 2: LỊCH SỬ PHIẾU GIAO DỊCH -->
      <v-tab-item>
        <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
          <TransactionFilter @onFilterChanged="onFilterChange" />
        </v-card>
        <v-card outlined class="mx-4 elevation-0">
          <TransactionDataTable ref="transactionDataTable" />
        </v-card>
      </v-tab-item>

      <!-- TAB 3: BÁO CÁO THẺ KHO -->
      <v-tab-item>
        <v-card outlined class="mx-4 elevation-0">
          <StockReportView />
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <TransactionNewDialog :state="newDialog" @updated="onTransactionCreated" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TransactionDataTable from '@/modules/facility/transaction/TransactionDataTable.vue'
import TransactionFilter from '@/modules/facility/transaction/TransactionFilter.vue'
import StockByLocationTable from '@/modules/facility/transaction/StockByLocationTable.vue'
import StockReportView from '@/modules/facility/transaction/StockReportView.vue'

export default {
  name: 'FacilityTransactions',
  components: {
    Breadcrumbs,
    StockByLocationTable,
    TransactionDataTable,
    TransactionFilter,
    StockReportView,
    TransactionNewDialog: () => import('@/modules/facility/transaction/TransactionNewDialog.vue')
  },
  data() {
    return {
      activeTab: 0,
      newDialog: false
    }
  },
  methods: {
    onFilterChange(query) {
      if (this.$refs.transactionDataTable) {
        this.$refs.transactionDataTable.refresh(query)
      }
    },
    onTransactionCreated() {
      if (this.$refs.transactionDataTable) {
        this.$refs.transactionDataTable.refresh()
      }
    }
  }
}
</script>
